var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacchina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.845,
    height: 87.262,
    viewBox: "0 0 173.845 87.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coup\\xE8",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_110",
    "data-name": "Raggruppa 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_266",
    "data-name": "Tracciato 266",
    d: "M177.017,116.346H15.434a4.126,4.126,0,0,1-4.124-4.124V96.361a19.109,19.109,0,0,1,5.578-13.494l18.1-26.13A13.1,13.1,0,0,1,45.772,51.09H79.431A38.382,38.382,0,0,1,100.025,57.1l39.25,25.064h13.3a28.659,28.659,0,0,1,28.58,28.58v1.481A4.129,4.129,0,0,1,177.017,116.346Z",
    transform: "translate(-11.31 -51.076)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_68",
    "data-name": "Ellisse 68",
    cx: 16.553,
    cy: 16.553,
    r: 16.553,
    transform: "translate(18.919 50.156)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_69",
    "data-name": "Ellisse 69",
    cx: 16.553,
    cy: 16.553,
    r: 16.553,
    transform: "translate(118.18 50.156)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_267",
    "data-name": "Tracciato 267",
    d: "M51.866,51.08V82.165H15.84",
    transform: "translate(-9.57 -51.08)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_268",
    "data-name": "Tracciato 268",
    d: "M52.5,51.08V82.165h77.726",
    transform: "translate(4.507 -51.08)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_226",
    "data-name": "Linea 226",
    x2: 13.951,
    transform: "translate(59.706 44.205)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacchina);
export default __webpack_public_path__ + "static/media/macchina.b9239732c268b0fb1ec83bdca57a7c03.svg";
export { ForwardRef as ReactComponent };